const tab_sections = {
    overview: 'Übersicht',
    resource_management: 'Ressourcenverwaltung',
    user_management: 'Benutzerverwaltung',
    help_and_support: 'Hilfe und Support',
};
export default tab_sections;
